module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="form-controls add-breakpoint-lightbox settings">\n    <h2 class="header">Add Breakpoint</h2>\n    <p>Add a new Breakpoint to your Settings.</p>\n    <label data-unit="px">\n        <input type="number" min="1" step="1" class="new-breakpoint">\n    </label>\n    <div class="actions">\n        <button class="btn btn-primary pull-right ok" data-spinner-size="28" data-style="expand-right" disabled>OK</button>\n        <button class="btn btn-secondary pull-right cancel">Cancel</button>\n    </div>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/settings/breakpoint/AddBreakpointView.tpl
// module id = 2833
// module chunks = 0